import { useRef } from "react";

export default function sectionsRef(array?: number) {
  const refs = Array(array ?? 0)
    .fill(null)
    .map(() => useRef(null));

  const scrollToRef = (ref: any) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return {
    model: { refs },
    operations: { scrollToRef },
  };
}
